var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tips", style: { "justify-content": _vm.align } },
    [
      _c(
        "span",
        { staticClass: "tipsText" },
        [
          _vm._t("default", function () {
            return [_vm._v(" " + _vm._s(_vm.text) + " ")]
          }),
        ],
        2
      ),
      _c(
        "el-tooltip",
        { staticClass: "item", attrs: { content: _vm.tips, placement: "top" } },
        [
          _c("img", {
            staticClass: "iconText",
            attrs: { src: _vm.imgSrc ? _vm.imgSrc : _vm.TipsImg },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }